(function () {
    'use strict';
    $(document).ready(function () {

        if ($('.homepage').length) {
            const $filtersForm = $('.area-filters-form');

            const $jobsSwiper = $('.jobs-swiper');
            const jobsSwiper = new Swiper('.jobs-swiper', {
                spaceBetween: 16,
                slidesPerView: 'auto',
                scrollbar: {
                    el: '.swiper-scrollbar',
                    draggable: true,
                },
            });

            $filtersForm.find('input[type="checkbox"]').on('change', () => {
                const formData = $filtersForm.serializeArray().reduce((acc, { name, value }) => {
                    if (!acc?.[name]) {
                        acc[name] = [];
                    }
                    acc[name] = [...acc[name], value];
                    return acc;
                }, {})

                let filter = '.jobs-swiper .swiper-slide';
                $(filter).removeClass('active');

                if (formData?.['area-filter']) {
                    filter = formData['area-filter']
                        .map((slug) => `.jobs-swiper .swiper-slide[data-area="${slug}"]`)
                        .join(',')

                    $jobsSwiper.addClass('filtered');
                } else {
                    $jobsSwiper.removeClass('filtered');
                }

                $(filter).addClass('active');
                jobsSwiper.update();
            })


            $('.circle-nav .circle-nav-item').on('click', (e) => {
                const index = +e.currentTarget.dataset.index;
                const $nav = $(`.circle-tabs-list a#circle-tab-nav-${index}`);
                $nav.tab('show')
            })

            $('.circle-tab-nav').on('show.bs.tab', (e) => {
                const nextTab = e.target;
                const prevTab = e.relatedTarget;
                $(`.circle-nav .circle-nav-item[data-index="${nextTab.dataset.index}"]`).addClass('active')
                $(`.circle-nav .circle-nav-item[data-index="${prevTab.dataset.index}"]`).removeClass('active')
            })

        }


    });
}(jQuery));
